/**
 * Created by lu on 2018/5/11.
 */
var nb = require('../../nb');
module.exports = nb.define({
    parent:nb.view.List,
    view:{
        tag:'form'
    },
    method:{
        init:function () {
            var self = this;
            this.$().on('change','input[type="radio"]',function () {
                var index = $(this).parents('.radio-wrap').attr('data-list-index');
                var model = self.getModel();
                model.set('activeIndex',index);
            });
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/view/form/RadioList.js
// module id = 51
// module chunks = 0 2 3 8 9 15 22 23